

















import { Component, Mixins, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../../Pi/types'
import ProxyTypingAction from '../../../logic/Proxy/actions/ProxyTypingAction'

@Component
export default class TypingAction extends Mixins(UseFields) {
  @Prop() action!: ProxyTypingAction

  typingTimeChange(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.setTime(val)
    return arg
  }
}
